<template>
  <div id="sched-app">
    <router-view/>
  </div>
</template>

<script>

export default {
  mounted () {
    let channel = {}

    switch (this.$route.params.channel) {
      case 'main':
        channel = { label: '3ABN', value: 'main' }
        break
      case 'proc':
        channel = { label: '3ABN Proclaim Network', value: 'proc' }
        break
      case 'dare':
        channel = { label: '3ABN Dare to Dream Network', value: 'dare' }
        break
      case 'int':
        channel = { label: '3ABN International Network', value: 'int' }
        break
      case 'canada':
        channel = { label: '3ABN Canada', value: 'canada' }
        break
      case 'kids':
        channel = { label: '3ABN Kids Network', value: 'kids' }
        break
      case 'lat':
        channel = { label: '3ABN Latino Network', value: 'lat' }
        break
      case 'praise':
        channel = { label: '3ABN Praise Him Music Network', value: 'praise' }
        break
      case 'radio':
        channel = { label: '3ABN Radio Network', value: 'radio' }
        break
      default:
        channel = { label: '3ABN', value: 'main' }
        break
    }

    this.$store.dispatch('fetchData', { channel })
  }
}
</script>

<style scoped>
@import url(style.css);
</style>
